export default __webpack_public_path__ + "static/media/tree-sprig.0dee6ea4.png";